module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/150hKbC/tc-custom/9781467432542.jpg?1730408927535",
      "alt": "This image is the cover for the book A River of Words, Incredible Lives for Young Readers (ILYR)"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("A River of Words, Incredible Lives for Young Readers (ILYR)\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("2009 Caldecott Honor Book")]), _c('br'), _c('b', [_vm._v("An ALA Notable Book")]), _c('br'), _c('b', [_vm._v("A New York Times Best Illustrated Children’s Book")]), _c('br'), _c('b', [_vm._v("A Charlotte Zolotow Honor Book")]), _c('br'), _c('b', [_vm._v("NCTE Notable Children’s Book")]), _c('br'), _c('br'), _vm._v(" When he wrote poems, he felt as free as the Passaic River as it rushed to the falls. Willie’s notebooks filled up, one after another. Willie’s words gave him freedom and peace, but he also knew he needed to earn a living. So he went off to medical school and became a doctor -- one of the busiest men in town! Yet he never stopped writing poetry. In this picture book biography of William Carlos Williams, Jen Bryant’s engaging prose and Melissa Sweet’s stunning mixed-media illustrations celebrate the amazing man who found a way to earn a living and to honor his calling to be a poet.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Jen Bryant, Melissa Sweet\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Jen Bryant has written numerous books for young readers,including Georgia's Bones and A River ofWords, winner of the Charlotte Zolotow Honor Award.Her book A Splash of Red (Knopf)received the Schneider Family Book Award and theNCTE Orbis Pictus Award for nonfiction. She lives inPennsylvania.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Wm. B. Eerdmans Publishing Co.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 71
// module chunks = 0